import React, { useState } from 'react';
import Navigation from '../../Components/Navigation';
import './Services_page.css';
import { FiEdit2, FiTrash2, FiPlus, FiSave, FiX } from 'react-icons/fi';

const Service_page = () => {
  const [services, setServices] = useState([
    {
      id: 1,
      title: 'Market Analysis',
      description: 'Comprehensive market analysis and insights to help you make informed investment decisions.',
      features: [
        'Real-time market data',
        'Technical analysis',
        'Fundamental analysis',
        'Market trends'
      ],
      isActive: true
    },
    {
      id: 2,
      title: 'Portfolio Management',
      description: 'Professional portfolio management services to optimize your investment returns.',
      features: [
        'Asset allocation',
        'Risk management',
        'Performance tracking',
        'Portfolio rebalancing'
      ],
      isActive: true
    },
    {
      id: 3,
      title: 'Investment Advisory',
      description: 'Expert investment advice tailored to your financial goals and risk tolerance.',
      features: [
        'Personalized strategies',
        'Investment planning',
        'Wealth management',
        'Retirement planning'
      ],
      isActive: true
    }
  ]);

  const [editingService, setEditingService] = useState(null);
  const [isAddingService, setIsAddingService] = useState(false);
  const [newService, setNewService] = useState({
    title: '',
    description: '',
    features: [''],
    isActive: true
  });

  const handleEdit = (service) => {
    setEditingService({ ...service });
  };

  const handleSave = () => {
    if (editingService) {
      setServices(services.map(service => 
        service.id === editingService.id ? editingService : service
      ));
      setEditingService(null);
    }
  };

  const handleDelete = (id) => {
    setServices(services.filter(service => service.id !== id));
  };

  const handleAddFeature = () => {
    setNewService(prev => ({
      ...prev,
      features: [...prev.features, '']
    }));
  };

  const handleRemoveFeature = (index) => {
    setNewService(prev => ({
      ...prev,
      features: prev.features.filter((_, i) => i !== index)
    }));
  };

  const handleFeatureChange = (index, value) => {
    setNewService(prev => ({
      ...prev,
      features: prev.features.map((feature, i) => i === index ? value : feature)
    }));
  };

  const handleAddService = () => {
    if (newService.title && newService.description && newService.features[0]) {
      setServices([...services, { ...newService, id: services.length + 1 }]);
      setNewService({
        title: '',
        description: '',
        features: [''],
        isActive: true
      });
      setIsAddingService(false);
    }
  };

  return (
    <div className="page-container">
      <Navigation />
      <div className="services-container">
        <div className="services-header">
          <h1>Manage Services</h1>
          <button 
            className="add-service-btn"
            onClick={() => setIsAddingService(true)}
          >
            <FiPlus /> Add New Service
          </button>
        </div>

        {isAddingService && (
          <div className="edit-service-form">
            <h2>Add New Service</h2>
            <div className="form-group">
              <label>Service Title</label>
              <input
                type="text"
                value={newService.title}
                onChange={(e) => setNewService({ ...newService, title: e.target.value })}
                placeholder="Enter service title"
              />
            </div>
            <div className="form-group">
              <label>Description</label>
              <textarea
                value={newService.description}
                onChange={(e) => setNewService({ ...newService, description: e.target.value })}
                placeholder="Enter service description"
                rows="3"
              />
            </div>
            <div className="form-group">
              <label>Features</label>
              {newService.features.map((feature, index) => (
                <div key={index} className="feature-input-group">
                  <input
                    type="text"
                    value={feature}
                    onChange={(e) => handleFeatureChange(index, e.target.value)}
                    placeholder="Enter feature"
                  />
                  <button 
                    className="remove-feature-btn"
                    onClick={() => handleRemoveFeature(index)}
                  >
                    <FiX />
                  </button>
                </div>
              ))}
              <button 
                className="add-feature-btn"
                onClick={handleAddFeature}
              >
                Add Feature
              </button>
            </div>
            <div className="form-actions">
              <button 
                className="cancel-btn"
                onClick={() => setIsAddingService(false)}
              >
                Cancel
              </button>
              <button 
                className="save-btn"
                onClick={handleAddService}
              >
                <FiSave /> Save Service
              </button>
            </div>
          </div>
        )}

        <div className="services-grid">
          {services.map(service => (
            <div key={service.id} className="service-card">
              {editingService?.id === service.id ? (
                <div className="edit-service-form">
                  <div className="form-group">
                    <label>Service Title</label>
                    <input
                      type="text"
                      value={editingService.title}
                      onChange={(e) => setEditingService({ ...editingService, title: e.target.value })}
                    />
                  </div>
                  <div className="form-group">
                    <label>Description</label>
                    <textarea
                      value={editingService.description}
                      onChange={(e) => setEditingService({ ...editingService, description: e.target.value })}
                      rows="3"
                    />
                  </div>
                  <div className="form-group">
                    <label>Features</label>
                    {editingService.features.map((feature, index) => (
                      <div key={index} className="feature-input-group">
                        <input
                          type="text"
                          value={feature}
                          onChange={(e) => {
                            const newFeatures = [...editingService.features];
                            newFeatures[index] = e.target.value;
                            setEditingService({ ...editingService, features: newFeatures });
                          }}
                        />
                        <button 
                          className="remove-feature-btn"
                          onClick={() => {
                            const newFeatures = editingService.features.filter((_, i) => i !== index);
                            setEditingService({ ...editingService, features: newFeatures });
                          }}
                        >
                          <FiX />
                        </button>
                      </div>
                    ))}
                    <button 
                      className="add-feature-btn"
                      onClick={() => {
                        setEditingService({
                          ...editingService,
                          features: [...editingService.features, '']
                        });
                      }}
                    >
                      Add Feature
                    </button>
                  </div>
                  <div className="form-actions">
                    <button 
                      className="cancel-btn"
                      onClick={() => setEditingService(null)}
                    >
                      Cancel
                    </button>
                    <button 
                      className="save-btn"
                      onClick={handleSave}
                    >
                      <FiSave /> Save Changes
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <div className="service-header">
                    <h2>{service.title}</h2>
                    <div className="service-actions">
                      <button 
                        className="edit-btn"
                        onClick={() => handleEdit(service)}
                      >
                        <FiEdit2 />
                      </button>
                      <button 
                        className="delete-btn"
                        onClick={() => handleDelete(service.id)}
                      >
                        <FiTrash2 />
                      </button>
                    </div>
                  </div>
                  <p className="service-description">{service.description}</p>
                  <div className="service-features">
                    {service.features.map((feature, index) => (
                      <div key={index} className="feature-item">
                        <span className="feature-dot"></span>
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>
                  <div className="service-status">
                    <span className={`status-badge ${service.isActive ? 'active' : 'inactive'}`}>
                      {service.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Service_page;
